import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'office-ui-fabric-react';
import { useSelector } from 'react-redux';
import { allSubjectAreasSelector } from '../../../../features/apiFeatures/subjectAreaSlice';
import { allHearingTypesSelector } from '../../../../features/apiFeatures/hearingTypeSlice';
import { hearingStatusForActivePageSelector } from '../../../../features/apiFeatures/hearingStatusSlice';
import { hearingOwnersByHearingIds } from '../../../../features/apiFeatures/userSlice';
import {
  hearingStatusOptionsMapperWithNoSelection,
  optionsMapperWithNoSelection,
} from '../../../../utilities/mapperFunctions';
import {
  filterAndSortingKeys,
  sortingOptions,
} from '../../../../utilities/filterAndSortingsUtil';
import { allCityAreasSelector } from '../../../../features/apiFeatures/cityAreaSlice';

const dropdownStyles = {
  dropdown: {
    width: 180,
    height: 32,
  },
  dropdownOptionText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

const FiltersAndSortings = ({
  disableOwner,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
  hearingIds,
}) => {
  const { t: translator } = useTranslation();
  const subjectAreas = useSelector(allSubjectAreasSelector);
  const cityAreas = useSelector(allCityAreasSelector);
  const hearingTypes = useSelector(allHearingTypesSelector);
  const hearingStatuses = useSelector(hearingStatusForActivePageSelector);
  const hearingOwners = useSelector(hearingOwnersByHearingIds(hearingIds));
  const onChangeFilter = (filterKey) => (_, value) => {
    let currFilterAndSortingSelection = Object.assign(
      {},
      filterAndSortingSelection,
    );
    currFilterAndSortingSelection[filterKey] = value.key;
    setFilterAndSortingSelection(currFilterAndSortingSelection);
  };
  return (
    <div className="admin-page-container-filters">
      <div className="admin-page-container-filters-specific">
        <Dropdown
          // ***********SUBJECT AREA***************
          label={translator('hearingProperties.subjectArea')}
          options={optionsMapperWithNoSelection(translator)(subjectAreas)}
          styles={dropdownStyles}
          onChange={onChangeFilter(filterAndSortingKeys.subjectArea)}
          selectedKey={
            filterAndSortingSelection[filterAndSortingKeys.subjectArea]
          }
        />
      </div>
      <div className="admin-page-container-filters-specific">
        <Dropdown
          // ***********CITY AREA***************
          label={translator('hearingProperties.cityArea')}
          options={optionsMapperWithNoSelection(translator)(cityAreas)}
          styles={dropdownStyles}
          onChange={onChangeFilter(filterAndSortingKeys.cityArea)}
          selectedKey={filterAndSortingSelection[filterAndSortingKeys.cityArea]}
        />
      </div>
      <div className="admin-page-container-filters-specific">
        <Dropdown
          // ***********HEARING STATUS***************
          label={translator('hearingProperties.hearingStatus')}
          options={hearingStatusOptionsMapperWithNoSelection(translator)(
            hearingStatuses,
          )}
          styles={dropdownStyles}
          onChange={onChangeFilter(filterAndSortingKeys.hearingStatus)}
          selectedKey={
            filterAndSortingSelection[filterAndSortingKeys.hearingStatus]
          }
        />
      </div>
      <div className="admin-page-container-filters-specific">
        <Dropdown
          // ***********HEARING TYPE***************
          label={translator('hearingProperties.hearingType')}
          options={optionsMapperWithNoSelection(translator)(hearingTypes)}
          styles={dropdownStyles}
          onChange={onChangeFilter(filterAndSortingKeys.hearingType)}
          selectedKey={
            filterAndSortingSelection[filterAndSortingKeys.hearingType]
          }
        />
      </div>
      {!disableOwner && (
        <div className="admin-page-container-filters-specific">
          <Dropdown
            // ***********HEARING OWNER***************
            label={translator('hearingProperties.hearingOwner')}
            options={optionsMapperWithNoSelection(translator)(
              hearingOwners,
              'employeeDisplayName',
            )}
            styles={dropdownStyles}
            onChange={onChangeFilter(filterAndSortingKeys.hearingOwner)}
            selectedKey={
              filterAndSortingSelection[filterAndSortingKeys.hearingOwner]
            }
          />
        </div>
      )}
      <div className="admin-page-container-filters-specific">
        <Dropdown
          // ***********SORTING***************
          label={translator('global.sorting')}
          options={sortingOptions(translator)}
          styles={dropdownStyles}
          onChange={onChangeFilter(filterAndSortingKeys.sortingKey)}
          selectedKey={
            filterAndSortingSelection[filterAndSortingKeys.sortingKey]
          }
        />
      </div>
    </div>
  );
};

export { FiltersAndSortings };
